import { DocumentsTableFilters } from '../types';

export function filterTableDataByFiltersValues(
  data: any[] | undefined,
  filters: DocumentsTableFilters,
  fields: Record<keyof DocumentsTableFilters, string>
) {
  const isFiltersEmpty = !Object.values(filters).filter(Boolean).length;

  if (isFiltersEmpty) return data;

  const filterAction: Record<keyof DocumentsTableFilters, (task: any) => boolean> = {
    type: doc => filters.type.includes('all') || filters.type.includes(doc?.[fields.type]),
    search: doc => doc?.[fields.search]?.toLowerCase()?.includes(filters.search.toLowerCase()),
  };

  return data?.filter(row => Object.values(filterAction).every(fn => fn(row))) || [];
}
